import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { DEFAULT_HEIGHT, DEFAULT_WIDTH } from './constants';
import type { StanBarChartProps } from './types';
import { useStanBarChartOptions } from './hooks/useStanBarChartOptions';
import styles from './StanBarChart.module.css';
import { cn } from '@/lib/utils/cn';

export const StanBarChart: React.FC<StanBarChartProps> = ({
    height = DEFAULT_HEIGHT,
    width: _width = DEFAULT_WIDTH,
    className,
    color,
    ...rest
}) => {
    // ApexCharts options hook
    const { options, resolvedSeries } = useStanBarChartOptions({
        color,
        ...rest,
    });

    return (
        <div className={cn(styles.container, className)}>
            <ReactApexChart
                className={styles.chart}
                type='bar'
                options={options}
                series={resolvedSeries}
                height={height}
                width='100%'
            />
        </div>
    );
};

export default StanBarChart;
